import { TFunction } from 'i18next';
import { formatedDate, formatNumericValue } from 'utils/general';

import { ISettlements } from '@/modules/Settlements/types';
import { formatAccountingPeriod } from '@/shared/components/molecules/CreateSettlement/logic';

interface Props {
  t: TFunction<'common', undefined>;
  isssuedCount: number;
  paidCount: number;
  underIssuanceCount: number;
}
export default function getTabsList({
  t,
  isssuedCount,
  underIssuanceCount,
}: Props) {
  const tabsList: {
    label: string;
    value: ISettlements.ISettlementsStatus;
    count: number;
  }[] = [
    { label: t('under_issuance'), value: 1, count: underIssuanceCount },
    { label: t('issued'), value: 2, count: isssuedCount },
  ];

  return tabsList;
}

export const getCardData = (
  settelment: ISettlements.ISettlementItem,
  language: string,
  currency: string
) => {
  const issuanceOrCreationDate = {
    key: settelment.status === 1 ? 'creation-Date' : 'issuing-date',
    value:
      settelment.status === 1
        ? settelment.creationDate || '-'
        : settelment.issuanceDate || '-',
  };

  return {
    'settelment-Id': `#${settelment.id || '-'}`,
    [issuanceOrCreationDate.key]: formatedDate(
      issuanceOrCreationDate.value,
      'd MMMM yyyy',
      language
    ),
    'accounting-period': formatAccountingPeriod({
      startDate: settelment.startDate,
      endDate: settelment.endDate,
      language,
    }),
    team_leader: settelment.supplierName,
    'created-by-whom': settelment.createdBy,
    'issued-by-whom': settelment.issuedBy ?? '-',
    'crop-type': settelment.crops.join(', '),
    netDues: settelment
      ? `${formatNumericValue(settelment.totalAmount)} ${currency || ''}`
      : '-',
  };
};
